import React from 'react';

import s from './style.module.css';

type Heading3Props = {
    title: string;
};

export const Heading3 = (props: Heading3Props) => {
    return <h3 className={s.heading}>{props.title}</h3>;
};

export default Heading3;
